import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import './index.scss'

/**
 * Our standard Text component uses an html input.  IE Edge has a known issue with not being able to spell check input
 * elements.  Use this component when a user will be entering words in a field that should be spell checked. i.e.
 * inputs in the publisher and survey components.
 *
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/13929893/
 *
 * @example
 * <TextWithSpellCheck
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Text" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   placeholder={<FormattedMessage id="SomePlaceholder" defaultMessage="Some Placeholder" />}
 *   required
 * />
 */
const TextWithSpellCheck = ({ className, onChange, ...props }: any) => (
  <Field
    {...props}
    className={cn('form__textwithspellcheck', className)}
    render={({ formik, ...field }: any) => {
      return (
        <textarea
          spellCheck="true"
          {...field}
          onBlur={formik.handleBlur}
          onChange={handleChange(formik, onChange)}
          rows="1"
        />
      )
    }}
  />
)

const handleChange = (formik: any, onChange: any) => {
  return (e: any) => {
    const updatedValue = e.target.value.replaceAll(/[\n\v\r]+/g, '')
    e.target.value = updatedValue

    if (onChange) {
      onChange(e)
    }

    formik.handleChange(e)
  }
}

TextWithSpellCheck.displayName = 'TextWithSpellCheck'

TextWithSpellCheck.propTypes = {
  ...propTypes,
  placeholder: PropTypes.string
}

TextWithSpellCheck.defaultProps = {
  ...defaultProps,
  placeholder: ''
}

export default TextWithSpellCheck
